import { api_fetch_throws } from "./client"

/** A distributor email data source ("Add distributor source" on the file-imports page). */
export interface EmailSourceJson {
  id: string
  name: string
  /** Legacy `source` enum value when this distributor has one (e.g. "unfi"); null for custom sources. */
  source: string | null
  default_custom_deduction_method: string | null
  sender_emails: string[]
  sender_domains: string[]
  subject_patterns: string[]
  dispute_email: string | null
  backup_request_email: string | null
  example_message_id: string | null
  notes: string | null
  /** Global rows are visible to every brand and editable only by system admins. */
  is_global: boolean
}

export interface UpsertEmailSourceRequest {
  name?: string
  default_custom_deduction_method?: string
  /** Full addresses ("ap@unfi.com") and domains ("@unfi.com") mixed; the server splits them. */
  sender_entries?: string[]
  subject_patterns?: string[]
  dispute_email?: string
  backup_request_email?: string
  example_message_id?: string
  notes?: string
  /** System admins only: promote a brand source to a global one. */
  make_global?: boolean
}

/** A synced email matching the example-email search in the dialog. */
export interface ExampleEmailJson {
  message_id: string
  from_email: string | null
  from_name: string | null
  subject: string
  date: string
}

export async function listEmailSources(): Promise<EmailSourceJson[]> {
  return api_fetch_throws<EmailSourceJson[]>("/email-source")
}

export async function createEmailSource(req: UpsertEmailSourceRequest): Promise<EmailSourceJson> {
  return api_fetch_throws<EmailSourceJson>("/email-source", { body: req })
}

export async function updateEmailSource(id: string, req: UpsertEmailSourceRequest): Promise<EmailSourceJson> {
  return api_fetch_throws<EmailSourceJson>(`/email-source/${id}`, { method: "PATCH", body: req })
}

export async function deleteEmailSource(id: string): Promise<void> {
  await api_fetch_throws<void>(`/email-source/${id}`, { method: "DELETE" })
}

export async function searchExampleEmails(q: string): Promise<ExampleEmailJson[]> {
  return api_fetch_throws<ExampleEmailJson[]>("/email-source/example-emails", { params: { q } })
}
